import React from "react";
import { useLang } from "../context/LangContext";

export default function Marquee() {
  const { t } = useLang();
  const phrase = t("home.available");
  const items = Array.from({ length: 8 });
  return (
    <div className="hairline-t hairline-b bg-base overflow-hidden py-5" data-testid="marquee">
      <div className="flex whitespace-nowrap marquee-track">
        {items.concat(items).map((_, i) => (
          <span key={i} className="font-serif-luxe italic text-2xl md:text-3xl text-[var(--ink)]/85 mx-10 inline-flex items-center gap-10">
            {phrase}
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--gold)]" />
          </span>
        ))}
      </div>
    </div>
  );
}
